import React, { useContext, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import api from '@totem/utilities/api';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';
import fileUtilities from '@totem/utilities/fileUtilities';

const TicketExportButton = () => {
  const { buildParameters } = useContext(InputContext);
  const [loading, setLoading] = useState<boolean>(false);

  const exportData = async () => {
    setLoading(true);

    const params = buildParameters();

    const { data } = await api.post(`${TICKETS_ENDPOINT}/export`, params);
    fileUtilities.downloadFile('tickets', data);

    setLoading(false);
  };

  return (
    <Button
      type="default"
      icon={<DownloadOutlined />}
      onClick={exportData}
      loading={loading}
    >
      Export CSV
    </Button>
  );
};

export default TicketExportButton;
